import store from '@/vuex/store';

export default {
  beforeEnter: (to, from, next) => {
    if (store.getters.isAuthenticated) {
      next();

      return;
    }

    next('/login');
  },

};
